import React from 'react';
import { Countries } from '../../core/util/msisdn';
import './flag.css';
import se from './se.svg';
import dk from './dk.svg';
import no from './no.svg';
import gl from './gl.svg';
import fi from './fi.svg';
import { useLanguageContext } from '../../core/locale/LanguageContext';

interface FlagProps {
  country: Countries;
  onClick?: () => void;
}

export default function Flag({ country, onClick }: FlagProps): React.ReactNode {
  const languageContext = useLanguageContext();

  const { alt, src } = {
    [Countries.Denmark]: { src: dk, alt: languageContext.countryLocalization.denmark.language },
    [Countries.Sweden]: { src: se, alt: languageContext.countryLocalization.sweden.language },
    [Countries.Finland]: { src: fi, alt: languageContext.countryLocalization.finland.language },
    [Countries.Norway]: { src: no, alt: languageContext.countryLocalization.norway.language },
    [Countries.Greenland]: { src: gl, alt: languageContext.countryLocalization.denmark.language },
  }[country];

  if (onClick) {
    return (
      <button type="button" className="flag-button" onClick={onClick}>
        <img className="flag" src={src} alt={alt} />
      </button>
    );
  }

  return <img className="flag" src={src} alt={alt} />;
}
